export const FILTERS = {
    DATE_CREATED: "DATE_CREATED",
    ALPHABETICAL: "ALPHABETICAL",
    CLASS_TYPE: "CLASS_TYPE",
    LAST_MODIFIED: "LAST_MODIFIED",
};
